import React, { Component } from 'react';
import img from '../images/productIntroduction.jpg'
import img1 from '../images/gz.jpg'
import img2 from '../images/app_shou.png'
import img3 from '../images/jijianQRCode.jpg'
import img4 from '../images/shoujianQRCode.jpg'

class Productions extends Component {
    constructor(props) {
		super(props)
		this.state = {}
	}
    render() {
        return (
            <div className="productIntroduction">
				<div className="content">
					<div className="img">
						<img src={img} />
						<ul className="codeList">
							<li>
								<img src={img1} />
								<p>十间鱼公众号</p>
							</li>
							<li>
								<img src={img2} />
								<p>十间鱼安卓收件端</p>
							</li>
							<li>
								<img src={img3} />
								<p>十间鱼寄件小程序</p>
							</li>
							<li>
								<img src={img4} />
								<p>十间鱼收件小程序</p>
							</li>
						</ul>
					</div>
				</div>
			</div>
        )
    }
}

export default Productions;